import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface UnsupportedScreenProps {
  countryName: string | null;
}

const UnsupportedScreen: React.FC<UnsupportedScreenProps> = ({ countryName }) => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        backgroundColor: 'rgba(10, 14, 20, 0.97)',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        textAlign: 'center',
        padding: '32px 24px',
      }}
    >
      <div style={{ fontSize: 64, marginBottom: 24, lineHeight: 1 }}>ℹ️</div>
      <h2 style={{ fontWeight: 700, fontSize: '1.6rem', marginBottom: 12, color: '#fff' }}>
        {t('geo.unsupported_screen_title', { defaultValue: 'Region Not Supported' })}
      </h2>
      <p style={{ fontSize: '1rem', color: '#b0bec5', maxWidth: 480, lineHeight: 1.7, marginBottom: 24 }}>
        {t('geo.unsupported_screen_body', {
          country: countryName ?? t('geo.your_region', { defaultValue: 'your region' }),
          defaultValue:
            'We do not currently offer onboarding services in {{country}}. Thank you for your interest.',
        })}
      </p>
      <Link 
        to="/global-availability"
        style={{ color: '#38bdf8', textDecoration: 'none', marginBottom: 32, fontSize: '1rem' }}
      >
        View full global availability list &rarr;
      </Link>
      <div style={{ display: 'inline-block', padding: '8px 20px', borderRadius: 8, background: 'rgba(148, 163, 184, 0.15)', border: '1px solid rgba(148, 163, 184, 0.35)', color: '#cbd5e1', fontSize: '0.82rem', maxWidth: 460, lineHeight: 1.5 }}>
        {t('geo.unsupported_legal', { defaultValue: 'If you are a resident of a supported region but are traveling, please try again when you return, or disable your VPN.' })}
      </div>
    </div>
  );
};

export default UnsupportedScreen;
